import * as Types from "../actionTypes/socketTypes";

export const setSocketViewerInfo = (payload) => ({
  type: Types.SOCKET_VIEWER_INFO,
  data: payload,
});
